<script setup>
import { translator } from '@shop/frontend/web/js/services/TranslatorService';

const emit = defineEmits(["removeBulkInfoLabel"]);

</script>

<template>
    <div class="bulk-buy-teacher__info-block">
        <span>
            <svg class="i-acquirings-button__bulk-buy-teacher_tooltip bulk-buy-teacher__info-block_icon" width="20" height="20" fill="none">
                    <use xlink:href="#attention"></use>
            </svg>
            {{ translator.t("order", "You can generate a link for collective purchase of tickets if there is only 1 event in your order") }}
        </span>
        <button
			class="i-ticket__remove-button reset-btn"
			type="button"
			title="Удалить"
			@click="emit('removeBulkInfoLabel')"
		>
			<svg height="15" width="15">
				<use xlink:href="#close"></use>
			</svg>
		</button>
    </div>
</template>